// extracted by mini-css-extract-plugin
export default {"mainImageWrapper":"styles_mainImageWrapper__Li9NH","cardImage":"styles_cardImage__VaRRh","mobileImage":"styles_mobileImage__2NnL-"};